import { TPPClaimsState } from "@/models/store/TPPClaimsState";

export const tenantInfoMutations = {
  setTenantLocationCode: (state: TPPClaimsState, locationCode: string) => {
    state.selectedTPPClaim!.facility_location_code = locationCode;
  },
  setTenantFirstName: (state: TPPClaimsState, firstName: string) => {
    state.selectedTPPClaim!.reporter_first_name = firstName;
  },
  setTenantLastName: (state: TPPClaimsState, lastName: string) => {
    state.selectedTPPClaim!.reporter_last_name = lastName;
  },
  setTenantEmailAddress: (state: TPPClaimsState, emailAddress: string) => {
    state.selectedTPPClaim!.owner_email = emailAddress;
  },
  setTenantPhone: (state: TPPClaimsState, phoneNumber: string) => {
    state.selectedTPPClaim!.reporter_phone = phoneNumber;
  },
  setTenantHomeAddress: (state: TPPClaimsState, homeAddress: string) => {
    state.selectedTPPClaim!.owner_address_1 = homeAddress;
  },
  setTenantAddressTwo: (state: TPPClaimsState, addressTwo: string) => {
    state.selectedTPPClaim!.owner_address_2 = addressTwo;
  },
  setTenantCity: (state: TPPClaimsState, city: string) => {
    state.selectedTPPClaim!.owner_city = city;
  },
  setTenantState: (state: TPPClaimsState, stateAbbr: string) => {
    state.selectedTPPClaim!.owner_state = stateAbbr;
  },
  setTenantZipCode: (state: TPPClaimsState, zipCode: string) => {
    state.selectedTPPClaim!.owner_zip_code = zipCode;
  },
  setTenantCounty: (state: TPPClaimsState, county: string) => {
    state.selectedTPPClaim!.owner_county = county;
  }
};
